import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Icon } from "@iconify/react";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { InputField, DatePickerField, SelectField } from "../../FormFields";

const resignedPostdocOption = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "On Process",
    label: "On Process",
  },
  {
    value: "No Postdoc resigned",
    label: "No Postdoc resigned",
  },
  {
    value: "I don't have C2F Postdoc",
    label: "I don't have C2F Postdoc",
  },
];

const resignedStudentOption = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "On Process",
    label: "On Process",
  },
  {
    value: "No PhD student resigned",
    label: "No PhD student resigned",
  },
  {
    value: "I don't have C2F PhD student",
    label: "I don't have C2F PhD student",
  },
];

export default function WorkingExperience(props) {
  const {
    formField: {
      //page3
      postdocFellowshipRecieve,
      typeAllPostdocs,
      postdocCurrently,
      postdocUnderSupervision,
      resignedPostdoc,
      phdScholarship,
      allPhDStudents,
      phdStudents,
      studentUnderSupervision,
      resignedStudent,
    },
  } = props;

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Working Experience
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <InputField
            name={postdocFellowshipRecieve.name}
            label={postdocFellowshipRecieve.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={typeAllPostdocs.name}
            label={typeAllPostdocs.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={postdocCurrently.name}
            label={postdocCurrently.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={postdocUnderSupervision.name}
            label={postdocUnderSupervision.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={resignedPostdoc.name}
            label={resignedPostdoc.label}
            data={resignedPostdocOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={phdScholarship.name}
            label={phdScholarship.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={allPhDStudents.name}
            label={allPhDStudents.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={phdStudents.name}
            label={phdStudents.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={studentUnderSupervision.name}
            label={studentUnderSupervision.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <SelectField
            name={resignedStudent.name}
            label={resignedStudent.label}
            data={resignedStudentOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
